<template>
  <div class="grid-actions-menu">
    <DropDownList
      text="Table Options"
      buttonClass="grid-actions-menu__button"
      :dataItems="actions"
      textField="text"
      dataItemKey="action"
      value-render="valueTemplate"
      size="small"
      :value="null"
      :popup-settings="{ className: 'table-options-popup' }"
      itemRender="itemTemplate"
    >
      <template v-slot:valueTemplate>
        <div class="grid-actions-menu__value">Table Options</div>
      </template>
      <template v-slot:itemTemplate="{ props }">
        <li
          class="k-list-item"
          @click="(ev: any) => {props.onClick(ev); onItemClick(props.dataItem)}"
        >
          <span class="k-list-item-text">{{ props.dataItem.text }}</span>
        </li>
      </template>
    </DropDownList>
  </div>
</template>

<script setup lang="ts">
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { computed } from "vue";
import type { GridMenuAction } from "../../../Domain/GridMenuAction";
import { GridMenuActionType } from "../../../Domain/GridMenuActionType";

const emit = defineEmits<{
  (e: "actionClicked", actionType: GridMenuActionType): void;
}>();

const props = defineProps<{
  additionalActions?: GridMenuAction[];
  overrideActions?: GridMenuAction[];
}>();

const defaultActions = [
  {
    action: GridMenuActionType.ClearAllFilters,
    text: "Clear All Filters",
  },
  {
    action: GridMenuActionType.ResetColumnSelection,
    text: "Reset Column Selection",
  },
  {
    action: GridMenuActionType.ResetColumnSizes,
    text: "Reset Column Sizes",
  },
  {
    action: GridMenuActionType.ResetPagination,
    text: "Reset Pagination",
  },
  {
    action: GridMenuActionType.ResetColumnOrder,
    text: "Reset Column Order",
  },
  {
    action: GridMenuActionType.ResetAllSettings,
    text: "Reset All",
  },
] as GridMenuAction[];

const actions = computed(() => {
  const result = props.overrideActions ?? defaultActions;
  if (props.additionalActions) {
    return [...result, ...props.additionalActions];
  }
  return result;
});

const onItemClick = (item: GridMenuAction) => {
  console.debug("GridActionsMenu, onItemClick", item);
  const action = item.action as GridMenuActionType;
  if (action != undefined && action != null) emit("actionClicked", action);
};
</script>

<style lang="scss">
.grid-actions-menu {
  &__button {
    height: 30px;

    .k-image {
      width: 12px;
      height: 12px;
    }
  }

  &__value {
    display: flex;
    align-items: center;
    margin-left: 8px !important;
    min-width: 90px;
  }
}

.table-options-popup {
  .k-list-item.k-selected {
    background-color: unset;
    color: black;
  }
}
</style>
